<template>
  <div class="navbar-container">
    <div class="admin-message">
      <div class="name">影像中心</div>
      <div class="version">v3.0</div>
    </div>
    <el-dropdown class="user-head-container" @command="handleCommand">
      <div class="user-info">
        <div class="user-headimg">
          <img :src="adminMessage.headimg || $store.state.default_img_url">
        </div>
        <span>{{adminMessage.name || 'admin'}}</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="showMessage">个人信息</el-dropdown-item>
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <mask-layer v-model="isShow1">
      <div class="content">
        <div class="left">
          <div class="img">
            <img :src="adminMessage.headimg || $store.state.default_img_url"/>
          </div>
          <p>
            <em>{{adminMessage.name}}</em>
          </p>
        </div>
        <div class="right">
          <p>
            <span class="title">手机：</span><em>{{adminMessage.phone}}</em>
          </p>
          <p>
            <span class="title">邮箱：</span><em>{{adminMessage.email}}</em>
          </p>
          <p>
            <span class="title">性别：</span><em>{{adminMessage.gender}}</em>
          </p>
          <p>
            <span class="title">城市：</span><em>{{adminMessage.city || '未知'}}</em>
          </p>
          <p>
            <span class="title">工号：</span><em>{{adminMessage.number}}</em>
          </p>
          <!-- <p>
            <span class="title">微信：</span>
            <el-button class="main-color" type="text" size="small" v-if="adminMessage.is_bind_wechat">已绑定</el-button>
            <el-button class="main-color" type="text" size="small" v-else @click="bindWechat">绑定微信</el-button>
          </p> -->
        </div>
      </div>
    </mask-layer>
    <mask-layer v-model="isShow2">
      <div class="bind-wechat">
        <h3>使用微信扫码</h3>
        <div class="qrcode">
          <img :src="`data:image/jpeg;base64,${qrcodeUrl}`" alt="">
        </div>
        <el-button type="primary" class="btn" @click="havedBindWechat">扫码绑定后点击此处</el-button>
        <p class="tips" v-if="qrcodeUrl">二维码两分钟内有效，请在规定时间内完成操作</p>
      </div>
    </mask-layer>
  </div>
</template>
<script>
import { removeToken } from '@/utils/auth'
import MaskLayer from '@/components/MaskLayer'
import request from '@/utils/request'

export default {
  name: 'Navbar',
  components: {
    MaskLayer
  },
  data () {
    return {
      isShow1: false,
      isShow2: false,
      qrcodeUrl: ''
    }
  },
  computed: {
    adminMessage: function () {
      return this.$store.state.adminMessage
    }
  },
  methods: {
    handleCommand (command) {
      if (command === 'logout') {
        removeToken()
        this.$store.commit('SET_TOKEN', '')
        this.$router.replace({ path: '/login' })
      }
      if (command === 'showMessage') {
        this.isShow1 = true
      }
    },
    bindWechat () {
      this.isShow2 = true
      request({
        url: 'bind-wechat-qrcode',
        method: 'get'
      }).then(res => {
        this.qrcodeUrl = res.data.qrcode
      })
    },
    havedBindWechat () {
      this.isShow2 = false
      this.$store.dispatch('GetAdminInfo').then()
    }
  }
}
</script>
<style lang="less">
.navbar-container {
  width: 100%;
  height: 50px;
  background-color: #3c8dbc!important;
  .admin-message {
  float: left;
  height: 50px;
  line-height: 50px;
  color: #ffffff;
  .name {
    float: left;
    width: 100px;
    background-color: #367FA9;
    text-align: center;
  }
  .version {
    float: left;
    margin-left: 20px;
    font-size: 13px;
  }
}
  .user-head-container {
    float: right;
  }
  .my-shops {
    float: right;
    margin-top: 12px;
    margin-right: 40px;
    width: 130px;
    background-color: rgba(0, 0, 0, 0)!important;
  }
  .user-info {
    float: right;
    margin-right: 20px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
    span {
      margin-left: 5px;
    }
  }
  .user-headimg {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    background-color: #dddddd;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    width: 830px;
    height: 500px;
    display: flex;
    padding: 0!important;
    font-size: 13px;
    color: #303133;
    p {
      line-height: 37px;
    }
    em {
      padding-right: 10px;
      font-style: normal;
    }
    span.title {
      color: #999999;
      font-size: 12px;
    }
    .left {
      width: 230px;
      height: 100%;
      border-right: 1px solid #EBEEF5;
      text-align: center;
      .img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        background-color: #dddddd;
        margin: 0 auto;
        margin-top: 70px;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .right {
      width: 600px;
      height: 100%;
      p {
        &:nth-child(1) {
          margin-top: 65px;
        }
        span.title {
          padding-right: 20px;
          padding-left: 40px;
        }
        .time {
          padding: 0;
        }
      }
    }
  }
  .bind-wechat {
    width: 600px;
    height: 500px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    h3 {
      text-align: center;
      margin-bottom: 20px;
      font-size: 26px;
      color: #111111;
    }
    .qrcode {
      margin: 0 auto;
      width: 250px;
      height: 250px;
      padding: 20px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
      svg {
        width: 100%;
        height: 100%;
      }
    }
    .btn {
      width: 210px;
    }
    .tips {
      color: red;
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue